import { LazyAction, LazyImport, LazyModule } from 'owa-bundling';
import { lazyActionWithErrorHandler } from 'mini-error-handler/lib/utils/lazyActionWithErrorHandler';
import { lazyImportWithErrorHandler } from 'mini-error-handler';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "TriageAction" */ './lazyIndex')
);

export const lazyApplyConversationFlaggedState = lazyActionWithErrorHandler(
    new LazyAction(lazyModule, m => m.applyConversationFlaggedState)
);
export const lazyApplyItemFlaggedState = lazyActionWithErrorHandler(
    new LazyAction(lazyModule, m => m.applyItemFlaggedState)
);
export const lazyApplySelectedConversationsFlaggedState = lazyActionWithErrorHandler(
    new LazyAction(lazyModule, m => m.applySelectedConversationsFlaggedState)
);
export const lazyApplySelectedItemsFlaggedState = lazyActionWithErrorHandler(
    new LazyAction(lazyModule, m => m.applySelectedItemsFlaggedState)
);
export const lazyDeleteConversation = lazyActionWithErrorHandler(
    new LazyAction(lazyModule, m => m.deleteConversation)
);
export const lazyDeleteSelectedConversations = lazyActionWithErrorHandler(
    new LazyAction(lazyModule, m => m.deleteSelectedConversations)
);
export const lazyMoveConversation = lazyImportWithErrorHandler(
    new LazyImport(lazyModule, m => m.moveConversation)
);
export const lazyMoveItem = lazyActionWithErrorHandler(new LazyAction(lazyModule, m => m.moveItem));
export const lazyMoveSelectedItems = lazyActionWithErrorHandler(
    new LazyAction(lazyModule, m => m.moveSelectedItems)
);
export const lazyMoveSelectedConversations = lazyActionWithErrorHandler(
    new LazyAction(lazyModule, m => m.moveSelectedConversations)
);
export const lazyMarkItemsAsRead = lazyActionWithErrorHandler(
    new LazyAction(lazyModule, m => m.markItemsAsRead)
);
export const lazyMarkConversationAsRead = lazyActionWithErrorHandler(
    new LazyAction(lazyModule, m => m.markConversationAsRead)
);
export const lazyMarkSelectedConversationsReadState = lazyActionWithErrorHandler(
    new LazyAction(lazyModule, m => m.markSelectedConversationsReadState)
);
export const lazyMarkSelectedItemsReadState = lazyActionWithErrorHandler(
    new LazyAction(lazyModule, m => m.markSelectedItemsReadState)
);

export const lazyMarkItemJunkNotJunk = lazyActionWithErrorHandler(
    new LazyAction(lazyModule, m => m.markItemJunkNotJunk)
);
export const lazyMarkConversationJunkNotJunk = lazyActionWithErrorHandler(
    new LazyAction(lazyModule, m => m.markConversationJunkNotJunk)
);
export const lazyMarkSelectedConversationsJunkNotJunk = lazyImportWithErrorHandler(
    new LazyImport(lazyModule, m => m.markSelectedConversationsJunkNotJunk)
);
export const lazyMarkSelectedItemsJunkNotJunk = lazyActionWithErrorHandler(
    new LazyAction(lazyModule, m => m.markSelectedItemsJunkNotJunk)
);
export const lazyMarkItemsAsPhising = lazyActionWithErrorHandler(
    new LazyAction(lazyModule, m => m.markItemsAsPhising)
);
export const lazyMarkSenderAsBlocked = lazyActionWithErrorHandler(
    new LazyAction(lazyModule, m => m.markSenderAsBlocked)
);
export const lazyArchiveRow = lazyActionWithErrorHandler(
    new LazyAction(lazyModule, m => m.archiveRow)
);
export const lazyPinConversation = lazyActionWithErrorHandler(
    new LazyAction(lazyModule, m => m.pinConversation)
);
export const lazyPinItems = lazyActionWithErrorHandler(new LazyAction(lazyModule, m => m.pinItems));

export const lazyMoveConversationToFocusedOrOther = lazyActionWithErrorHandler(
    new LazyAction(lazyModule, m => m.moveConversationToFocusedOrOther)
);
export const lazyMoveItemToFocusedOrOther = lazyActionWithErrorHandler(
    new LazyAction(lazyModule, m => m.moveItemToFocusedOrOther)
);
export const lazyUnsubscribeItem = new LazyAction(lazyModule, m => m.unsubscribeItem);
export const lazyDeleteItemFromCompose = lazyActionWithErrorHandler(
    new LazyAction(lazyModule, m => m.deleteItemFromCompose)
);
export const lazyDeleteItemFromReadingPane = lazyActionWithErrorHandler(
    new LazyAction(lazyModule, m => m.deleteItemFromReadingPane)
);
export const lazyDeleteItemsWithoutConfirmDialog = lazyActionWithErrorHandler(
    new LazyAction(lazyModule, m => m.deleteItemsWithoutConfirmDialog)
);
export const lazyDeleteSelectedItems = lazyActionWithErrorHandler(
    new LazyAction(lazyModule, m => m.deleteSelectedItems)
);

export const lazyReactToItem = lazyActionWithErrorHandler(
    new LazyAction(lazyModule, m => m.reactToItem)
);

export const lazyAutoMarkConversationAsRead = lazyActionWithErrorHandler(
    new LazyAction(lazyModule, m => m.autoMarkConversationAsRead)
);

export const lazyMarkSendersAsUnblocked = lazyActionWithErrorHandler(
    new LazyAction(lazyModule, m => m.markSendersAsUnblocked)
);

export const lazyDeleteMailsFromSender = lazyActionWithErrorHandler(
    new LazyAction(lazyModule, m => m.deleteMailsFromSender)
);
